import type { SVGProps } from 'react';

export function RadioUnchecked(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
      <circle
        cx="8"
        cy="8"
        r="7.5"
        style={{
          stroke: 'var(--radio-foreground-color, currentColor)',
          fill: 'var(--radio-background-color, white)',
        }}
      />
    </svg>
  );
}

export function RadioChecked(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" {...props}>
      <circle cx="8" cy="8" r="8" style={{ fill: 'var(--radio-foreground-color, currentColor)' }} />
      <circle cx="8" cy="8" r="3" style={{ fill: 'var(--radio-background-color, white)' }} />
    </svg>
  );
}
